import { render, staticRenderFns } from "./PrintDetailDialog.vue?vue&type=template&id=50118f22&"
import script from "./PrintDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./PrintDetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50118f22')) {
      api.createRecord('50118f22', component.options)
    } else {
      api.reload('50118f22', component.options)
    }
    module.hot.accept("./PrintDetailDialog.vue?vue&type=template&id=50118f22&", function () {
      api.rerender('50118f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/cust/trenker/shared/HourOverview/components/Dialogs/PrintDetailDialog.vue"
export default component.exports